import DeleteAllCuratedButton from './DeleteAllCuratedButton';
export default DeleteAllCuratedButton;
export * from './DeleteAllCuratedButton';
